<!-- <div class="max-w-320 mx-auto px-4 pt-8 sm:px-8 sm:pt-16">
    <div class="grid grid-cols-2">
        <div class="col-span-2 md:col-span-1 max-w-100 w-full mx-auto">
            <a href="https://fakturnia.pl">
                <img src="/assets/images/logo_full_size.png" class="w-40">
            </a>
        </div>
    </div>
</div> -->
<router-outlet *ngIf="true"></router-outlet>